import "./SolutionProvider.css";

const modules = [
  {
    name: "CRM Modules",
    features: [
      "Lead and opportunity management",
      "Pipeline stages and deal forecasting",
      "Contact and company profiles",
      "Task, call, and follow-up tracking",
      "Reports and activity logs",
    ],
    cost: "60,000 BDT",
    duration: "3-4 weeks",
  },
  {
    name: "Sales & Project Management",
    features: [
      "Proposal and quotation builder",
      "Project milestones and delivery plan",
      "Team assignments and workload view",
      "Time tracking and productivity",
      "Client updates and approvals",
    ],
    cost: "60,000 BDT",
    duration: "3-4 weeks",
  },
  {
    name: "HRM System",
    features: [
      "Employee profiles and onboarding",
      "Attendance, leave, and shift",
      "Payroll and compensation",
      "Performance review cycles",
      "HR analytics dashboard",
    ],
    cost: "20,000 BDT",
    duration: "3-4 weeks",
  },
  {
    name: "Accounting & Payment",
    features: [
      "Income, expense, and ledger",
      "Invoice and payment tracking",
      "Tax and compliance reporting",
      "Payment gateway integration",
      "Reconciliation workflow",
    ],
    cost: "70,000 BDT",
    duration: "2-3 weeks",
  },
  {
    name: "Integration Modules",
    features: [
      "Email and SMS notifications",
      "WhatsApp and chat alerts",
      "Google calendar sync",
      "Open API and webhooks",
      "Third-party tools bridge",
    ],
    cost: "20,000 BDT",
    duration: "2-3 weeks",
  },
  {
    name: "Mobile Apps (Customer + Team)",
    features: [
      "Flutter apps for iOS and Android",
      "Push notifications",
      "Offline mode for field team",
      "Approval and status updates",
      "Secure login and access",
    ],
    cost: "70,000 BDT",
    duration: "4-5 weeks",
  },
  {
    name: "Web Admin Panel",
    features: [
      "Role-based access control",
      "Centralized dashboards",
      "Settings and master data",
      "Audit trails and logs",
      "Data export and backup",
    ],
    cost: "50,000 BDT",
    duration: "3-4 weeks",
  },
];

const timeline = [

  { label: "Requirement analysis", weeks: "Week 1", progress: 10 },
  { label: "Server setup", weeks: "Week 1", progress: 15 },
  { label: "Core modules build", weeks: "Week 3-6", progress: 60 },
  { label: "Integrations and apps", weeks: "Week 7-12", progress: 80 },
  { label: "QA, training, launch", weeks: "Week 12-14", progress: 100 },
];

const paymentSteps = [
  { label: "Start payment", value: "30% at kickoff" },
  { label: "Midway milestone", value: "30% after core modules" },
  { label: "Before launch", value: "30% before go-live" },
  { label: "After launch", value: "10% after success drive" },
];


export const SolutionProvider = () => {
  return (
    <section className="solution" id="solution-provider">
      <header className="solution__hero">
        <p className="solution__eyebrow">Budget Estimation Package</p>
        <h1 className="solution__title">
          BrainToDo - Custom CRM + HRM for Solution Provider
        </h1>
        <p className="solution__subtitle">
          ERP helps you unify sales, HR, finance, and delivery in one system,
          reduce manual work, and make faster, data-driven decisions across the
          business.
        </p>
      </header>

      <section className="solution__modules">
        <div className="solution__section-head">
          <h2>Module Pricing Breakdown</h2>
          <p>Each module includes design, development, QA, and deployment.</p>
        </div>
        <div className="solution__cards">
          {modules.map((module) => (
            <article className="solution__card" key={module.name}>
              <div className="solution__card-top">
                <h3>{module.name}</h3>
                <span className="solution__pill">{module.duration}</span>
              </div>
              <ul className="solution__list">
                {module.features.map((feature) => (
                  <li key={feature}>{feature}</li>
                ))}
              </ul>
              <div className="solution__card-foot">
                <span>Estimated cost</span>
                <strong>{module.cost}</strong>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="solution__summary">
        <div className="solution__summary-card">
          <div>
            <p className="solution__summary-label">Total Estimated Project Cost</p>
            <h3>350,000 BDT</h3>
          </div>
        </div>
      </section>

      <section className="solution__timeline">
        <div className="solution__section-head">
          <h2>Timeline Roadmap (12-14 Weeks)</h2>
          <p>Clear delivery path with visible milestones and progress.</p>
        </div>
        <div className="solution__timeline-grid">
          {timeline.map((item) => (
            <div className="solution__timeline-item" key={item.label}>
              <div className="solution__timeline-header">
                <h4>{item.label}</h4>
                <span>{item.weeks}</span>
              </div>
              <div className="solution__progress">
                <div style={{ width: `${item.progress}%` }} />
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="solution__payment">
        <div className="solution__section-head">
          <h2>Payment Structure</h2>
          <p>Transparent and milestone-based payments for confidence.</p>
        </div>
        <div className="solution__payment-grid">
          {paymentSteps.map((step) => (
            <div className="solution__payment-card" key={step.label}>
              <p>{step.label}</p>
              <strong>{step.value}</strong>
            </div>
          ))}
        </div>
      </section>

      <section className="solution__stack">
        <div className="solution__section-head">
          <h2>Stack Details</h2>
          <p>Built with proven technologies for scale and long-term support.</p>
        </div>
        <div className="solution__stack-card">
          <ul>
            <li>Android and iOS with Flutter.</li>
            <li>Website and admin panel frontend with React JS.</li>
            <li>Backend and API with Laravel.</li>
          </ul>
        </div>
      </section>

    </section>
  );
};
